import { render, staticRenderFns } from "./BasicWorkPane2.vue?vue&type=template&id=47d84a2f&scoped=true&"
import script from "./BasicWorkPane2.vue?vue&type=script&lang=js&"
export * from "./BasicWorkPane2.vue?vue&type=script&lang=js&"
import style0 from "./BasicWorkPane2.vue?vue&type=style&index=0&id=47d84a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d84a2f",
  null
  
)

export default component.exports